
export default {
  'profileManagement.title': 'Gestion de Profil',
  'profileManagement.save': 'Enregistrer les Modifications',
  'profileManagement.personal_info': 'Informations Personnelles',
  'profileManagement.services': 'Services',
  'profileManagement.gallery': 'Galerie',
  'profileManagement.availability': 'Disponibilité',
  'profileManagement.locations': 'Emplacements',
  'profileManagement.privacy': 'Paramètres de Confidentialité',
  'profileManagement.verification': 'Vérification',
  'profileManagement.subscription': 'Abonnement',
  'profileManagement.add_photo': 'Ajouter une Photo',
  'profileManagement.delete_photo': 'Supprimer',
  'profileManagement.set_as_main': 'Définir comme Principale',
  'profileManagement.services.add': 'Ajouter un Service',
  'profileManagement.services.remove': 'Supprimer',
  'profileManagement.locations.add': 'Ajouter un Emplacement',
  'profileManagement.locations.remove': 'Supprimer',
  'profileManagement.inactive': 'Afficher comme inactif',
  'profileManagement.hide_profile': 'Masquer le profil des recherches',
  'profileManagement.anonymous_mode': 'Mode Anonyme',
  'profileManagement.upload_image': 'Télécharger une Image',
  'profileManagement.upload_image_success': 'Image téléchargée avec succès',
  'profileManagement.upload_image_error': 'Échec du téléchargement de l\'image',
  'profileManagement.select_profile': 'Sélectionner un Profil',
  'profileManagement.upload': 'Télécharger',
  'profileManagement.admin_tools': 'Gérer les Images de Profil'
};
